import { Tag } from './_Tag';
import { Group } from '../group/Group';

Tag.Group = Group;

export { Tag };
